import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../toast/toast.service';
import { TENANT_ACCESS_LOST_MESSAGE } from './tenant-access-lost.error';

/** Long enough to read the sentence while the org selection is already showing. */
const TENANT_ACCESS_LOST_TOAST_MS = 6000;

/**
 * Tells the user that the remembered organization is gone and sends them to the
 * org selection. Clearing the stored selection is done by `UserService`, which
 * detects the 403; the session itself stays valid - only a 401 means "log out".
 */
@Injectable({
  providedIn: 'root',
})
export class TenantAccessService {
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  /** Opens the org selection first (no-op when already there), then explains why. */
  public async handleAccessLost(): Promise<void> {
    try {
      await this.router.navigateByUrl('/org-selection');
    } catch (error) {
      // The user must still learn why the organization is gone, and callers must still
      // receive TenantAccessLostError rather than a navigation error.
      console.warn('Navigation to the org selection failed.', error);
    }
    await this.toastService.displayWarningToast(
      TENANT_ACCESS_LOST_MESSAGE,
      TENANT_ACCESS_LOST_TOAST_MS
    );
  }
}
